(function () {
  'use strict';

  angular.module('wsLrs.services').factory("DataDropdownLinks", ['$rootScope', 'UserRoles', 'User', 'OrganizationSettings', function ($rootScope, UserRoles, User, OrganizationSettings) {
    return {
      get: function get() {
        var user = User.get();
        var isOrgAdmin = UserRoles.isOrgAdmin(user);
        var isOrgManager = UserRoles.isOrgManager(user);
        var isSysAdmin = UserRoles.isSystemAdmin(user);
        var canAccessStatementArchiving = OrganizationSettings.hasFeature("statementArchivingAccess") && isOrgAdmin || UserRoles.isSystemAdmin(user);
        return [{
          href: '#/data/start',
          condition: isOrgAdmin,
          section: 'start',
          display: 'Getting Started'
        }, {
          href: '#/data/search',
          condition: isOrgManager,
          section: 'search',
          display: 'Data Search'
        }, {
          href: '#/data/xapi',
          condition: isOrgAdmin,
          section: 'xapi',
          display: 'xAPI Data'
        }, {
          href: '#/data/csv',
          condition: isOrgAdmin,
          section: 'csv',
          display: 'CSV Data'
        }, {
          href: '#/data/activities',
          condition: isOrgAdmin,
          section: 'activities',
          display: 'Activities'
        }, {
          href: '#/data/verbs',
          condition: isOrgAdmin,
          section: 'verbs',
          display: 'Verbs'
        }, {
          href: '#/data/log',
          condition: isOrgAdmin,
          section: 'log',
          display: 'Error Log'
        }, {
          href: '#/data/stats',
          condition: isOrgAdmin,
          section: 'stats',
          display: 'Data Stats'
        }, {
          href: '#/data/learners',
          condition: isSysAdmin,
          display: 'Learner Status',
          section: 'learners'
        }, {
          href: '#/data/export',
          condition: isOrgAdmin,
          section: 'export',
          display: 'Export Data'
        }, {
          href: '#/data/resyncs',
          condition: isSysAdmin,
          section: 'resyncs',
          display: 'Resync Tasks'
        }, {
          href: '#/data/archive-rules',
          condition: canAccessStatementArchiving,
          section: 'archive-rules',
          display: 'Statement Archiving'
        }];
      }
    };
  }]);
})();
